import { render, staticRenderFns } from "./OrderFailurePage.vue?vue&type=template&id=56b2ee8c"
import script from "./OrderFailurePage.vue?vue&type=script&lang=js"
export * from "./OrderFailurePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports